import React from 'react';
import { ExternalLink, CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { SubmissionResult } from '@/hooks/useMonoXOneSubmission';

interface MonoXOneSubmissionResultProps {
  result: SubmissionResult;
  onClose: () => void;
}

export const MonoXOneSubmissionResult: React.FC<MonoXOneSubmissionResultProps> = ({
  result,
  onClose
}) => {
  if (!result) return null;

  // 処理中の場合
  if (result.stage === 'submitting' || result.stage === 'verifying') {
    return (
      <div className="mt-2 p-3 rounded border bg-blue-50/50 dark:bg-blue-900/10">
        <div className="flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-blue-500" />
          <span className="text-sm text-blue-700 dark:text-blue-300">
            {result.stage === 'submitting' ? 'MONO-X Oneに送信中...' : 'データ反映確認中...'}
          </span>
        </div>
      </div>
    );
  }

  // 成功の場合（Toastに移動）
  // if (result.success && result.url) {
  //   return (
  //     <div className="mt-2 p-3 rounded border bg-green-50/50 dark:bg-green-900/10">
  //       <div className="flex items-start gap-3">
  //         <CheckCircle className="w-5 h-5 text-green-500 mt-0.5" />
  //         <div className="flex-1">
  //           <div className="text-sm font-medium text-green-700 dark:text-green-300">
  //             送信完了
  //           </div>
  //           <div className="text-xs text-green-600 dark:text-green-400 mt-1">
  //             まもなく自動的にページを開きます...
  //           </div>
  //           <div className="mt-2">
  //             <a
  //               href={result.url}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //               className="inline-flex items-center gap-1 px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700 transition-colors"
  //             >
  //               <ExternalLink className="w-3 h-3" />
  //               公開ページを確認
  //             </a>
  //           </div>
  //           <details className="mt-2">
  //             <summary className="cursor-pointer text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
  //               詳細
  //             </summary>
  //             <div className="mt-1 p-2 bg-gray-50 dark:bg-gray-800/50 rounded text-xs text-gray-600 dark:text-gray-400">
  //               {result.verified ? '✓ データ反映確認済み' : '手動確認をお勧めします'}
  //             </div>
  //           </details>
  //         </div>
  //         <button
  //           onClick={onClose}
  //           className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 text-sm"
  //         >
  //           ×
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  // // エラーの場合（Toastに移動）
  // return (
  //   <div className="mt-2 p-3 rounded border bg-red-50/50 dark:bg-red-900/10">
  //     <div className="flex items-start gap-3">
  //       <XCircle className="w-5 h-5 text-red-500 mt-0.5" />
  //       <div className="flex-1">
  //         <div className="text-sm font-medium text-red-700 dark:text-red-300">
  //           送信に失敗しました
  //         </div>
  //         <details className="mt-2">
  //           <summary className="cursor-pointer text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
  //             詳細
  //           </summary>
  //           <div className="mt-1 p-2 bg-gray-50 dark:bg-gray-800/50 rounded text-xs text-red-600 dark:text-red-400">
  //             {result.error || 'エラーが発生しました'}
  //           </div>
  //         </details>
  //       </div>
  //       <button
  //         onClick={onClose}
  //         className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 text-sm"
  //       >
  //         ×
  //       </button>
  //     </div>
  //   </div>
  // );
}; 